import EnhancedRecommendationPage from '../components/EnhancedRecommendationPage'

const HomePage = () => {
  return <EnhancedRecommendationPage />
}

export default HomePage